import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const investmentMandateTypeService = createApi({
    reducerPath: 'investmentMandateTypeService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['InvestmentMandateType'],
    endpoints: (builder) => ({
        getAllInvestmentMandateType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMandateTypeController.getAllInvestmentMandateType}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getInvestmentMandateTypeById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMandateTypeController.getInvestmentMandateTypeById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveInvestmentMandateType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMandateTypeController.saveInvestmentMandateType}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateInvestmentMandateType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMandateTypeController.updateInvestmentMandateType}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteInvestmentMandateType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMandateTypeController.deleteInvestmentMandateType}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAllInvestmentMandateTypeBySearch: builder.mutation({
            query(body) {
                console.log(body, "body");

                return {
                    url: `${userManagement.investmentMandateTypeController.getAllInvestmentMandateTypeBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllInvestmentMandateType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMandateTypeController.findAllInvestmentMandateType}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveInvestmentMandateTypeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMandateTypeController.bulkSaveInvestmentMandateTypeMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});
export const {
    useGetAllInvestmentMandateTypeMutation,
    useGetInvestmentMandateTypeByIdMutation,
    useSaveInvestmentMandateTypeMutation,
    useUpdateInvestmentMandateTypeMutation,
    useDeleteInvestmentMandateTypeMutation,
    useGetAllInvestmentMandateTypeBySearchMutation,
    useFindAllInvestmentMandateTypeMutation,
    useBulkSaveInvestmentMandateTypeMasterMutation,
} = investmentMandateTypeService;